module.exports = __webpack_public_path__ + "img/direction.7d791daa.png";